export default __webpack_public_path__ + "static/media/arrow-up-icon.a2a04d90.svg";